import React, { useCallback } from 'react';
import { httpPost } from '../utils';

const AcknowledgmentPopover = ({ onHide, authControl }) => {
    const { isAuthorizedToUse, setIsAuthorizedToUse, isPermittedToApproveUsage } = authControl;

    const handleAcceptAcknowledgment = useCallback(async () => {
        await httpPost(`/chats/authorizeAiUsage`);
        setIsAuthorizedToUse(true);
    }, [setIsAuthorizedToUse]);

    if (isAuthorizedToUse || isAuthorizedToUse) {
        return null;
    }
    return (
        <div className="absolute flex h-full inset-0 bg-white bg-opacity-50 flex items-center justify-center z-[5000]">
            <div className="bg-white p-[24px] rounded-lg border-2 border-sf-gray-100 shadow-sf-medium max-w-sm">
                <p className="text-left mb-[24px] whitespace-pre-line leading-relaxed">
                    Silverfort AI Filter utilizes the Azure Open AI Service on Silverfort meta-data.{'\n'}Therefore,
                    usage of the Silverfort AI Filter may be subject to Microsoft's terms.
                </p>
                {isPermittedToApproveUsage && (
                    <div className="flex flex-col justify-center gap-[8px]">
                        <button
                            onClick={handleAcceptAcknowledgment}
                            className="flex py-2 rounded-xl justify-center bg-sf-purple-500 hover:bg-sf-purple-400 text-white">
                            Accept
                        </button>
                        <button
                            onClick={onHide}
                            className="flex py-2 rounded-xl justify-center bg-white hover:bg-sf-gray-100">
                            Cancel
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AcknowledgmentPopover;
